import { render, staticRenderFns } from "./PostFeed.vue?vue&type=template&id=e846fd3c&scoped=true&"
import script from "./PostFeed.vue?vue&type=script&lang=js&"
export * from "./PostFeed.vue?vue&type=script&lang=js&"
import style0 from "./PostFeed.vue?vue&type=style&index=0&id=e846fd3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e846fd3c",
  null
  
)

export default component.exports